import {
    DefaultAvatar as Avatar,
    DefaultAvatarProps,
    PROFILE_TYPE_GROUP
} from '@/components/base/Avatar';
import { SM, XS } from '@/types/utils/sizesType';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

export type ProfileType = SocialProfileType | SpGroupType;

type SpOrSpGroupAvatarProps = DefaultAvatarProps & {
    size: DefaultAvatarProps['size'];
    item: ProfileType & { avatarDisabled?: boolean };
    profileNetworkType?: boolean;
    profileGroupType?: boolean;
};

const SpOrSpGroupAvatar = ({
    item,
    size,
    profileNetworkType = true,
    profileGroupType = false,
    ...restProps
}: SpOrSpGroupAvatarProps) => {
    if (!item) {
        return null;
    }

    if ('social_network_type' in item) {
        return (
            <Avatar
                size={size}
                fallback={item?.slug?.[0]}
                url={item?.external_api_data?.avatar}
                aria-label={item?.slug}
                profileType={profileNetworkType ? item?.social_network_type : null}
                title={item?.slug}
                disabled={item?.avatarDisabled}
                {...restProps}
            />
        );
    }
    return (
        <Avatar
            size={size}
            radius={size === SM ? 'rounded-m' : size === XS ? 'rounded-sm' : 'rounded-md'}
            fallback={item?.name?.substring(0, 2)}
            url={item?.image}
            customColorClass={item?.fallback_style}
            title={item?.name}
            profileType={profileGroupType ? PROFILE_TYPE_GROUP : undefined}
            disabled={item?.avatarDisabled}
            {...restProps}
        />
    );
};

export default SpOrSpGroupAvatar;
